import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adobe-io-runtime-frequently-asked-questions"
    }}>{`Adobe I/O Runtime: Frequently Asked Questions`}</h1>
    <h2 {...{
      "id": "getting-access"
    }}>{`Getting Access`}</h2>
    <p><strong parentName="p">{`How can I get access to I/O Runtime?`}</strong><br parentName="p"></br>{`
`}{`Runtime is now part of App Builder. There are more details `}<a parentName="p" {...{
        "href": "../guides/overview/getting_access.md"
      }}>{`here`}</a>{` about how to get access.`}</p>
    <h2 {...{
      "id": "supported-programming-languages"
    }}>{`Supported Programming Languages`}</h2>
    <p><strong parentName="p">{`Which languages are supported in I/O Runtime?`}</strong><br parentName="p"></br>{`
`}{`For now, Adobe I/O Runtime only supports Node.js. We might add support for other languages in the future.`}</p>
    <h3 {...{
      "id": "node-version-18---default-image"
    }}>{`Node version 18 - Default Image`}</h3>
    <p>{`The NPM modules available with this image can be found `}<a parentName="p" {...{
        "href": "../guides/reference/runtimes.md#nodejs-v18"
      }}>{`here`}</a>{`.`}</p>
    <p>{`We encourage you to always update your actions to the latest version in order to take advantage of pre-warm containters feature.`}</p>
    <h3 {...{
      "id": "older-versions"
    }}>{`Older Versions`}</h3>
    <p>{`When a new Node version is added to the system, the old versions are still available. This means that your actions will still work. However, you won't be able to create new actions with these versions. We encourage you to always update your actions to the latest version in order to take advantage of the pre-warm containers feature.`}</p>
    <h2 {...{
      "id": "networking"
    }}>{`Networking`}</h2>
    <p><strong parentName="p">{`Are there any restrictions when it comes to ports and outbound connections?`}</strong></p>
    <p>{`When retrieving data from some external systems your code might need to connect to a SFTP server, SMTP server, or HTTP service. As long as that system uses one of following ports, your code should work fine:`}</p>
    <p><inlineCode parentName="p">{`21, 22, 25, 53, 80, 123, 143, [200-299], 389, 443, 445, 465, 587, 636, 1433, [2000-2999], 3000, 3306, 4242, 4317, 4343, 5400, 5432, 5671, 5672, 6061, 6062, 6379, 6380, 6651, 8000, 8020, 8080, 8085, 8088, 8089, 8300, 8500, 8600, 9090, 9092, 9093, 9094, [9096-9352], 9354, [10000-20000], 27016, 27017, 27018, 27019, 30303, 50010, 60020`}</inlineCode>{`.`}</p>
    <p>{`If you have a need for a port that is not in this list, please share with us the use case.`}</p>
    <p><strong parentName="p">{`Do the ingress IP addresses for Adobe I/O Runtime ever change?`}</strong></p>
    <p>{`Yes, the IP addresses returned when looking up an Adobe I/O Runtime endpoint's DNS record can change at any time. To avoid issues with connecting and routing to the platform, clients should not cache DNS-lookup responses for Adobe I/O Runtime endpoints beyond the TTL of the DNS record. For more information, see "`}<a parentName="p" {...{
        "href": "../guides/using/security_general.md#secure-communication-with-backend-services"
      }}>{`Secure Communication with Backend Services`}</a>{`" in the `}<a parentName="p" {...{
        "href": "../guides/using/security_general.md"
      }}>{`Security Guide`}</a>{`.`}</p>
    <h2 {...{
      "id": "usage-quotas"
    }}>{`Usage Quotas`}</h2>
    <p><strong parentName="p">{`What usage quotas are in place for Adobe I/O Runtime?`}</strong><br parentName="p"></br>{`
`}{`Runtime In terms of quotas for Runtime and other consumption features of App Builder like storage, etc., customers should refer to the number of units they purchased.Runtime, as part of App Builder, For information how much capacity is included  what is included `}</p>
    <h2 {...{
      "id": "multiple-region-support"
    }}>{`Multiple Region Support`}</h2>
    <p><strong parentName="p">{`Where we execute your actions`}</strong>{`
I/O Runtime runs in multiple regions. We deploy your code in all regions and execute it in the closest region to the caller (latency-based routing). You can't restrict the execution to a specific region only.`}</p>
    <p>{`You can find more information about the regions and how you can check where your actions are being executed here - `}<a parentName="p" {...{
        "href": "../guides/reference/multiple_regions.md"
      }}>{`Multiple Regions`}</a>{`.`}</p>
    <h2 {...{
      "id": "system-limits"
    }}>{`System Limits`}</h2>
    <p><strong parentName="p">{`Which limits are imposed onto actions?`}</strong><br parentName="p"></br>{`
`}{`All available limits (and the default values) are listed here: `}<a parentName="p" {...{
        "href": "../guides/using/system_settings.md"
      }}>{`System Settings`}</a>{`. Notable limits are the timeout for functions and the maximum payload that can get posted to a function.`}</p>
    <h2 {...{
      "id": "developer-support"
    }}>{`Developer Support`}</h2>
    <p>{`You can use the `}<a parentName="p" {...{
        "href": "https://forums.adobe.com/community/adobe-io/adobe-io-runtime"
      }}>{`Adobe I/O Runtime Forums`}</a>{` for developer support related questions. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      